export default "__VITE_ASSET__CiPKDe8v__"